export const SPORT_TABS = [
  { id: 4, name: "Cricket", icon: "🏏" },
  { id: 1, name: "Football", icon: "⚽" },
  { id: 2, name: "Tennis", icon: "🎾" },
];

export function parseTeams(matchName = "") {
  const parts = String(matchName).split(/\s+v\s+/i);
  if (parts.length >= 2) {
    return { team1: parts[0].trim(), team2: parts[1].trim() };
  }
  return { team1: matchName, team2: "Team 2" };
}

/**
 * Indian exchange math (matches settlement):
 * - Bookmaker / Fancy: rate is paise-style (38 ⇒ stake×38/100)
 *   BACK profit = stake × rate / 100 | risk = stake
 *   LAY  profit = stake             | risk (liability) = stake × rate / 100
 * - Match Odds (decimal):
 *   BACK profit = stake × (odds−1) | risk = stake
 *   LAY  profit = stake            | risk = stake × (odds−1)
 */
export function calcBetProfit(stake, odds, marketType = "bookmaker", betType = "back") {
  const s = Number(stake);
  const o = Number(odds);
  if (!s || !o) return "0.00";
  if (betType === "lay") {
    return s.toFixed(2);
  }
  if (marketType === "match_odds") {
    return (s * (o - 1)).toFixed(2);
  }
  // bookmaker + fancy back
  return ((s * o) / 100).toFixed(2);
}

/** Amount locked from balance while bet is open. */
export function calcBetLiability(stake, odds, marketType = "bookmaker", betType = "back") {
  const s = Number(stake);
  const o = Number(odds);
  if (!s || !o) return 0;
  if (betType === "back") return Math.round(s * 100) / 100;
  if (marketType === "match_odds") {
    return Math.round(s * (o - 1) * 100) / 100;
  }
  return Math.round(((s * o) / 100) * 100) / 100;
}

export function marketTypeFromLabel(label = "") {
  if (label === "Fancy") return "fancy";
  if (label === "Match Odds") return "match_odds";
  return "bookmaker";
}

/** Provider often sends broken maxBet (e.g. min 50, max 1). Sanitize for stake UI. */
export function normalizeBetLimits(minBet, maxBet, fallbackMin = 100, fallbackMax = 200000) {
  let min = Number(minBet);
  let max = Number(maxBet);
  if (!Number.isFinite(min) || min <= 0) min = fallbackMin;
  if (!Number.isFinite(max) || max <= 0) max = fallbackMax;
  // Broken feed: max lower than min (seen as "50-1" on Match Odds)
  if (max < min) max = fallbackMax;
  // Absurdly tiny max relative to min
  if (max < min * 2 && max < 1000) max = fallbackMax;
  return { min, max };
}

export function formatOdd(val) {
  const n = Number(val);
  if (!n || n <= 0) return "-";
  return n < 10 ? n.toFixed(2) : String(n);
}

export function resolveCasinoImage(name = "", index = 0) {
  const n = String(name).toLowerCase();

  if (n.includes("worli")) return "/Images/casino/worli-matka.jpg";
  if (n.includes("matka")) return "/Images/casino/matka.jpg";
  if (n.includes("oneday") || n.includes("one day") || n.includes("1 day")) {
    return "/Images/casino/teenpatti-onday-1exbet.png";
  }
  if (n.includes("teen") || n.includes("tp")) {
    if (n.includes("test")) return "/Images/casino/teen-patti-1-day-sky.jpg";
    if (n.includes("t20") || n.includes("20")) return "/Images/casino/1.jpg";
    return "/Images/casino/teen-patti-1-day-sky.jpg";
  }
  if (n.includes("dragon")) {
    return n.includes("2") || n.includes("two") || n.includes("20-20")
      ? "/Images/casino/dragon-tiger2.jpg"
      : "/Images/casino/dragon-tiger-sky.jpg";
  }
  if (n.includes("lucky") || n.includes("7a") || n.includes("7 a")) {
    return "/Images/casino/7.jpg";
  }
  if (n.includes("aaa")) return "/Images/casino/aaa.jpg";
  if (n.includes("32") || n.includes("card")) {
    return n.includes("b") ? "/Images/casino/8.jpg" : "/Images/casino/9.jpg";
  }
  if (n.includes("aviator")) return "/Images/casino/10.jpg";
  if (n.includes("ludo")) return "/Images/casino/11.jpg";
  if (n.includes("kabaddi")) return "/Images/casino/12.jpg";

  let hash = 0;
  for (let i = 0; i < n.length; i += 1) {
    hash = (hash * 31 + n.charCodeAt(i)) >>> 0;
  }
  return `/Images/casino/${((hash || index) % 13) + 1}.jpg`;
}
